import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'decrement'];
  static values = {
    delay: { type: Number, default: 500 },
    min: { type: Number, default: 0 },
  };

  disconnect() {
    clearTimeout(this.timer);
  }

  decrement() {
    this.apply(this.quantity - 1);
  }

  increment() {
    this.apply(this.quantity + 1);
  }

  typed(event) {
    if (event.detail?.debounced) return;

    event.stopPropagation();
    this.apply(this.quantity);
  }

  apply(quantity) {
    const next = Math.max(quantity, this.minValue);
    this.inputTarget.value = next;
    this.decrementTarget.disabled = next <= this.minValue;
    this.element.closest('.upsell-product')?.classList.toggle('upsell-product--selected', next > 0);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.inputTarget.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { debounced: true } }));
    }, this.delayValue);
  }

  get quantity() {
    return Number.parseInt(this.inputTarget.value, 10) || 0;
  }
}
